export default __webpack_public_path__ + "static/logo-black-00bdbdd2021fc9a57cf71e73f4f2da0b.png";